import React from 'react'
import { useRef, useEffect, useState } from 'react'
import { useResize } from '../UseResize'
import 'animate.css/animate.css'

import StatsTopCivs from './StatsTopCivs'
import StatsTopMaps from './StatsTopMaps'
import StatsByDuration from './StatsByDuration'

import Widget1vs1Advance from './Widget1vs1Advance'

import { useGlobalContext } from '../context'
import Widget1vs1CurrentMatch from './Widget1vs1CurrentMatch'

export default function Widget1vs1({ showExtendedInfo }) {
  const {
    hostProfile,
    hostStatsByCiv,
    hostStatsByMap,
    hostStatsByDuration,
    hostCurrentMatchColor,
    hostCurrentMatchCiv,
    guestProfile,
    guestCurrentMatchColor,
    guestCurrentMatchCiv,
    guestStatsByCiv,
    guestStatsByMap,
    guestStatsByDuration,
    currentMatchMap,
  } = useGlobalContext()

  const [statsShowed, setStatsShowed] = useState(0)
  const statsTypesHost = [
    <StatsTopCivs statsByCiv={hostStatsByCiv} />,
    <StatsTopMaps statsByMap={hostStatsByMap} />,
    <StatsByDuration statsByDuration={hostStatsByDuration} />,
  ]
  const statsTypesGuest = [
    <StatsTopCivs statsByCiv={guestStatsByCiv} />,
    <StatsTopMaps statsByMap={guestStatsByMap} />,
    <StatsByDuration statsByDuration={guestStatsByDuration} />,
  ]

  // Change user stats
  useEffect(() => {
    let intervalId = setInterval(() => {
      setStatsShowed((oldIndex) => {
        let index = oldIndex + 1
        if (index > statsTypesHost.length - 1) {
          index = 0
        }
        return index
      })
    }, 10000)
    return () => {
      clearInterval(intervalId)
    }
  }, [statsShowed, statsTypesHost.length])

  // Modify widtget background on window resize
  const widgetHeaderLeft = useRef()
  var { width, height } = useResize(widgetHeaderLeft)

  return (
    <>
      <div className='widget'>
        {showExtendedInfo ? statsTypesHost[statsShowed] : ''}
        <div className='widget-header'>
          <div className='widget-header-main-container'>
            <div
              className='widget-header-left-background'
              style={{
                height: `${height}px`,
                width: `${width}px`,
                background: `linear-gradient(90deg, ${hostCurrentMatchColor} 0%, ${hostCurrentMatchColor} 75%, #272c34 100% )`,
              }}
            ></div>
            <div className='widget-header-left' ref={widgetHeaderLeft}>
              <div className='widget-header-container-left'>
                <div className='player-info-and-last-civ'>
                  <div className='username-left'>
                    <div className='img-flag'>
                      <img
                        src={`./countries/${
                          hostProfile.country ? hostProfile.country : 'generic'
                        }.png`}
                        alt={hostProfile.country}
                      />
                    </div>
                    <p>{hostProfile.name}</p>
                  </div>
                  <div className='civ-last-match-left'></div>
                </div>
                <div className='elo-left'>
                  <h3>EW</h3>
                  <p>
                    {hostProfile.highestRatingEW1vs1
                      ? hostProfile.highestRatingEW1vs1
                      : '-'}
                  </p>
                  <p>
                    <b className='current-elo-player'>
                      {hostProfile.eloEW1vs1 ? hostProfile.eloEW1vs1 : '-'}
                    </b>
                  </p>
                </div>
                <div className='elo-left'>
                  <h3>RM</h3>
                  <p>
                    {hostProfile.highestRatingRM1vs1
                      ? hostProfile.highestRatingRM1vs1
                      : '-'}
                  </p>
                  <p>
                    <b className='current-elo-player'>
                      {hostProfile.eloRM1vs1 ? hostProfile.eloRM1vs1 : '-'}
                    </b>
                  </p>
                </div>
              </div>
              <div
                className='widget-header-left-color-bottom'
                style={{
                  background: `linear-gradient(90deg, ${hostCurrentMatchColor} 0%, ${hostCurrentMatchColor} 75%, #272c34 100% )`,
                }}
              ></div>
            </div>
            <div
              className='widget-header-right-background'
              style={{
                height: `${height}px`,
                width: `${width}px`,
                marginLeft: `${width + 4}px`,
                backgroundColor: guestCurrentMatchColor,
              }}
            ></div>
            <div className='widget-header-right'>
              <div className='widget-header-container-right'>
                <div className='elo-right'>
                  <h3>RM</h3>
                  <p>{guestProfile.highestRatingRM1vs1}</p>
                  <p>
                    <b className='current-elo-player'>
                      {guestProfile.eloRM1vs1}
                    </b>
                  </p>
                </div>
                <div className='elo-right'>
                  <h3>EW</h3>
                  <p>
                    {guestProfile.highestRatingEW1vs1
                      ? guestProfile.highestRatingEW1vs1
                      : '-'}
                  </p>
                  <p>
                    <b className='current-elo-player'>
                      {guestProfile.eloEW1vs1 ? guestProfile.eloEW1vs1 : '-'}
                    </b>
                  </p>
                </div>
                <div className='player-info-and-last-civ'>
                  <div className='username-right'>
                    <p>{guestProfile.name}</p>
                    <div className='img-flag'>
                      <img
                        src={`./countries/${
                          guestProfile.country
                            ? guestProfile.country
                            : 'generic'
                        }.png`}
                        alt={guestProfile.country}
                      />
                    </div>
                  </div>
                  <div className='civ-last-match-right'></div>
                </div>
              </div>
              <div
                className='widget-header-right-color-bottom'
                style={{
                  background: `linear-gradient(90deg, #272c34 0%, ${guestCurrentMatchColor} 25%, ${guestCurrentMatchColor} 100% )`,
                }}
              ></div>
            </div>
          </div>
          <Widget1vs1Advance
            hostProfile={hostProfile}
            guestProfile={guestProfile}
          />
        </div>

        {showExtendedInfo ? statsTypesGuest[statsShowed] : ''}
      </div>

      <Widget1vs1CurrentMatch
        currentMatchMap={currentMatchMap}
        hostCurrentMatchCiv={hostCurrentMatchCiv}
        guestCurrentMatchCiv={guestCurrentMatchCiv}
      />
    </>
  )
}
